import { useState, useEffect } from 'react'
import { useVestigioFixadoService } from 'hooks/useVestigioFixadoService'
import { useGerenciamentoBalisticaService } from 'hooks/useGerenciamentoBalisticaService'
import { cutMaxLength, maxLengthAndNumber } from 'utils/helpers'
import { isNatural } from 'helpers/validators'

const maxLength1000 = (newValue) => cutMaxLength(newValue, 1000)
const onlyNumber = (newValue) => maxLengthAndNumber(newValue, 10)

export const useFormVestigioFixado = ({
  idExameRealizado,
  idLocal,
  open,
  setOpen,
  setVestigiosFixados,
  setProcessandoVestigiosFixados,
}) => {
  const gerenciamentoBalisticoService = useGerenciamentoBalisticaService()
  const vestigioFixadoService = useVestigioFixadoService()

  const [tiposVestigiosFixados, setTiposVestigiosFixados] = useState([])
  const [processandoTiposVestigios, setProcessandoTiposVestigios] = useState(false)

  const [values, setValues] = useState({
    quantidade: 1,
    localizacao: '',
    tipo: null,
    marca: null,
    calibre: null,
    tipoInputText: '',
    marcaInputText: '',
    calibreInputText: '',
    observacao: '',
  })

  useEffect(() => {
    if (open) {
      setValues({
        quantidade: 1,
        localizacao: '',
        tipo: null,
        marca: null,
        calibre: null,
        tipoInputText: '',
        marcaInputText: '',
        calibreInputText: '',
        observacao: '',
      })
    }
  }, [open])

  useEffect(() => {
    gerenciamentoBalisticoService.listarOpcoesClassificacaoCartuchoGlobal(setProcessandoTiposVestigios)
    vestigioFixadoService.getTiposVestigiosFixados(setProcessandoTiposVestigios, setTiposVestigiosFixados)
  }, [])

  const handleChange = (e) => {
    const { name, value } = e.target
    let processedValue = value
    if (name === 'quantidade') {
      processedValue = onlyNumber(value)
    } else if (name === 'localizacao' || name === 'observacao') {
      processedValue = maxLength1000(value)
    }
    setValues((prev) => ({ ...prev, [name]: processedValue }))
  }

  const handleAutocompleteChange = (event, newValue, name) => {
    setValues((prev) => ({ ...prev, [name]: newValue }))
  }

  const getCampoSelectNome = (campo) => {
    if (values[campo] && values[campo].nome) {
      if (values[campo].nome.toLowerCase() === 'outro') {
        return values[`${campo}InputText`]
      }
      return values[campo].nome
    }
    return null
  }

  const handleConfirm = async () => {
    if (formError()) return
    const dados = {
      id_exame_local: idExameRealizado,
      id_local: idLocal,
      id_tipo: values.tipo ? values.tipo.id : null,
      ...values,
      marca: getCampoSelectNome('marca'),
      calibre: getCampoSelectNome('calibre'),
    }
    await vestigioFixadoService.cadastrarVestigioFixado(dados)
    vestigioFixadoService.getVestigiosFixadosDeLocalDoExame(
      idLocal,
      idExameRealizado,
      setVestigiosFixados,
      setProcessandoVestigiosFixados
    )
    setOpen(false)
  }

  const formError = () => {
    if (!values.tipo) {
      return true
    }
    if (!isNatural(values.quantidade)) {
      return true
    }
    if (!values.localizacao || !values.localizacao.trim()) {
      return true
    }
    return false
  }

  // Emulando a estrutura que a SelectComposto espera (um formState clássico com values, touched e errors)
  const formState = {
    values,
    touched: {},
    errors: {},
  }

  return {
    tiposVestigiosFixados,
    processandoTiposVestigios,
    values,
    handleChange,
    handleAutocompleteChange,
    handleConfirm,
    formError,
    formState,
  }
}
